document.addEventListener("DOMContentLoaded", function () {
  var sliderThumbnail = new Swiper(".thumbnail--list", {
    slidesPerView: 6.15,
    freeMode: false,
    spaceBetween: 8,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    breakpoints: {
      990: { slidesPerView: 7 },
    },
  });

  var slider = new Swiper(".product__media-list", {
    navigation: {
      prevEl: ".swiper--button--prev",
      nextEl: ".swiper--button--next",
    },
    slidesPerView: 1.1,
    spaceBetween: 16,
    autoHeight: true,
    loop: true,
    thumbs: {
      swiper: sliderThumbnail,
    },
    breakpoints: {
      990: { slidesPerView: 1 },
    },
  });

  var review_content_pdp_slider = new Swiper(".review-content-pdp-slider", {
    slidesPerView: 1,
    freeMode: false,
    spaceBetween: 5,
    autoHeight: true,
    autoplay: {
      delay: 10000,
      disableOnInteraction: false,
    },
    speed: 200,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    pagination: {
      el: ".slider__pagination",
      clickable: true,
    },
  });

  var as_seen = new Swiper(".as-seen-swiper", {
    spaceBetween: 60,
    loop: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    centeredSlides: true,
    speed: 5000,
    breakpoints: {
      0: { slidesPerView: 2.5,  spaceBetween: 24 },
      575: { slidesPerView: 3,  spaceBetween: 32 },
      768: { slidesPerView: 4,  spaceBetween: 40 },
      1099: { slidesPerView: 7 },
    },
  });

  var ingredients = new Swiper(".ingredients-slider", {
    spaceBetween: 10,
    loop: false,
    navigation: {
      prevEl: ".slider-prev",
      nextEl: ".slider-next",
    },
    pagination: {
      el: ".slider-dots",
      clickable: true,
    },
    breakpoints: {
      0: { slidesPerView: 1.08 },
      575: { slidesPerView: 2 },
      768: { slidesPerView: 3 },
      1099: { slidesPerView: 3.83 },
    },
  });

  var benefits_block_slider = new Swiper(".benefits-block-slider", {
    spaceBetween: 16,
    loop: false,
    navigation: {
      prevEl: ".slider-prev",
      nextEl: ".slider-next",
    },
    pagination: {
      el: ".slider-dots",
      clickable: true,
    },
    breakpoints: {
      0: { slidesPerView: 1.2 },
      575: { slidesPerView: 1.2 },
      768: { slidesPerView: 2.1 },
    },
  });

  var video_slider = new Swiper(".direkte-video-slider", {
    spaceBetween: 16,
    loop: false,
    navigation: {
      prevEl: ".slider-prev",
      nextEl: ".slider-next",
    },
    pagination: {
      el: ".slider-dots",
      clickable: true,
    },
    breakpoints: {
      0: { slidesPerView: 1.2 },
      575: { slidesPerView: 1.2 },
      768: { slidesPerView: 2.1 },
    },
  });

  document
    .querySelectorAll(".c-hi-item-video")
    .forEach(function (videoWrapper) {
      const playIcon = videoWrapper.querySelector(".play-icon");
      const video = videoWrapper.querySelector("video");
      const videoImage = videoWrapper.querySelector(".video-image");

      playIcon.addEventListener("click", function () {
        videoImage.style.display = "none";
        video.style.display = "block";
        video.play();
      });
    });

  /* button scroll */
  document
    .querySelectorAll(".pdp-sticky-form-blocks, .sc-pdp-product-features .feature-button, .aktivgel-comparison-section .comparison-btn")
    .forEach(function (element) {
      element.addEventListener("click", function (e) {
        e.preventDefault(); // Prevent default anchor behavior
        var href = this.getAttribute("href").replace("#", "");
        var target = document.querySelector(
          '.product__info-container .product-shopify-attributes[id="' +
            href +
            '"]'
        );

        if (target) {
          // Get the target's position minus 50px offset
          var targetPosition =
            target.getBoundingClientRect().top + window.pageYOffset - 100;

          window.scrollTo({
            top: targetPosition,
            behavior: "smooth",
          });
        }
      });
    });

  var swiper_slider_product_grid = new Swiper(".swiper-slider-product-grid", {
    spaceBetween: 10,
    loop: false,
    navigation: {
      prevEl: ".slider-prev",
      nextEl: ".slider-next",
    },
    pagination: {
      el: ".slider-dots",
      clickable: true,
    },
    breakpoints: {
      0: { slidesPerView: 1.078, spaceBetween: 16},
      575: { slidesPerView: 2.2 },
      769: { slidesPerView: 3.63 },
    },
  });

  var swiper = new Swiper(".blog-post-swiper", {
     slidesPerView: 3,
    spaceBetween: 16,
    loop: false,
    navigation: {
      prevEl: ".slider-prev",
      nextEl: ".slider-next",
    },
    pagination: {
      el: ".slider-dots",
      clickable: true,
    },
    breakpoints: {
      0: { 
        slidesPerView: 1, 
         spaceBetween: 16
      },
      575: {
        slidesPerView: 2 
      },
      992: { 
        slidesPerView: 3 
      },
    },
  });

  var cards_pdp = document.querySelectorAll(".recomm-product-tag");
  var maxHeight_pdp = 0;

  cards_pdp.forEach(function (card_pdp) {
    var cardHeight_pdp = card_pdp.offsetHeight;
    if (cardHeight_pdp > maxHeight_pdp) {
      maxHeight_pdp = cardHeight_pdp;
    }
  });

  cards_pdp.forEach(function (card_pdp) {
    card_pdp.style.minHeight = maxHeight_pdp + "px";
    // card_pdp.style.minHeight = "79px";
  });
  
});

/*document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".ingredients-slider");
  const cards = document.querySelectorAll(".ingredient-card");
  const dots = document.querySelectorAll(".slider-dot");
  const prevBtn = document.querySelector(".slider-prev");
  const nextBtn = document.querySelector(".slider-next");

  let currentIndex = 0;
  const cardWidth = slider.offsetWidth / Math.min(4, cards.length);

  // Set first dot as active
  if (dots.length > 0) {
    dots[0].classList.add("active");
  }

  function updateSlider() {
    slider.scrollTo({
      left: currentIndex * cardWidth,
      behavior: "smooth",
    });

    // Update dots
    dots.forEach((dot, index) => {
      dot.classList.toggle("active", index === currentIndex);
    });
  }

  // Click events for navigation
  prevBtn.addEventListener("click", function () {
    if (currentIndex > 0) {
      currentIndex--;
      updateSlider();
    }
  });

  nextBtn.addEventListener("click", function () {
    if (currentIndex < cards.length - 1) {
      currentIndex++;
      updateSlider();
    }
  });

  // Click events for dots
  dots.forEach((dot, index) => {
    dot.addEventListener("click", function () {
      currentIndex = index;
      updateSlider();
    });
  });

  // Optional: Add swipe functionality for mobile
  let touchStartX = 0;
  let touchEndX = 0;

  slider.addEventListener("touchstart", (e) => {
    touchStartX = e.changedTouches[0].screenX;
  });

  slider.addEventListener("touchend", (e) => {
    touchEndX = e.changedTouches[0].screenX;
    handleSwipe();
  });

  function handleSwipe() {
    if (touchEndX < touchStartX - 50 && currentIndex < cards.length - 1) {
      // Swipe left
      currentIndex++;
      updateSlider();
    } else if (touchEndX > touchStartX + 50 && currentIndex > 0) {
      // Swipe right
      currentIndex--;
      updateSlider();
    }
  }

  // Adjust for responsive layout
  function updateCardWidth() {
    let visibleCards = 4;

    if (window.innerWidth <= 992 && window.innerWidth > 768) {
      visibleCards = 3;
    } else if (window.innerWidth <= 768 && window.innerWidth > 480) {
      visibleCards = 2;
    } else if (window.innerWidth <= 480) {
      visibleCards = 1;
    }

    const newCardWidth =
      slider.offsetWidth / Math.min(visibleCards, cards.length);
    cardWidth = newCardWidth;
    updateSlider();
  }

  window.addEventListener("resize", updateCardWidth);
  updateCardWidth();
});*/
